import { ReactNode } from 'react';

import PropTypes from 'prop-types';

import useEffect from '../../../util/hook/useEffect';
import useState from '../../../util/hook/useState';

import { S } from './style';

import Loading from '../../atom/Loading';
import ConfigHeader from '../../helper/ConfigHeader';

// #NOTES
// We used to set min-height of the layout to 100vh, but it works unexpectedly on iOS safari.
// To fix this issue, we set the min-height to the innerHeight of the window instead.
// To learn more about this issue, please refer to the following links:
// https://medium.com/quick-code/100vh-problem-with-ios-safari-92ab23c852a8
// https://allthingssmitty.com/2020/05/11/css-fix-for-100vh-in-mobile-webkit/
// https://www.gss.com.tw/blog/css-safari-100vh
const usePageMinHeight = () => {
  const [minHeight, setMinHeight] = useState(window.innerHeight);

  useEffect(() => {
    const resizeListener = () => {
      const newMinHeight = window.innerHeight;
      setMinHeight(newMinHeight);
    };
    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  return { minHeight };
};

interface Props {
  isLoading: boolean;
  children?: ReactNode;
  customLayout?: string;
}

export default function PageLayout({ isLoading, children, customLayout }: Props): ReactNode {
  const { minHeight } = usePageMinHeight();

  return (
    <S.Layout minHeight={minHeight} customLayout={customLayout}>
      {isLoading ? <Loading /> : null}
      <ConfigHeader />
      {children}
    </S.Layout>
  );
}

PageLayout.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  customLayout: PropTypes.string,
};
